import * as React from 'react';
import clsx from 'clsx';

interface VisibilityCardProps {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  isSelected: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const VisibilityCard: React.FC<VisibilityCardProps> = ({
  title,
  subtitle,
  icon,
  isSelected,
  onClick,
  disabled,
}) => (
  <button
    type='button'
    onClick={onClick}
    disabled={disabled}
    className={clsx(
      'relative flex w-full items-start gap-4 rounded-20 border-2 p-4 text-left transition-all',
      isSelected ? 'border-brand-800 bg-purple-300' : 'border-black bg-white',
      disabled && 'cursor-not-allowed opacity-50'
    )}
  >
    <div className='flex h-full gap-2'>
      <div
        className={clsx(
          'flex size-[18px] items-center justify-center self-center rounded-full border',
          isSelected ? 'border-brand-800' : 'border-gray-400'
        )}
      >
        {isSelected && <div className='size-[10px] rounded-full bg-brand-800' />}
      </div>

      {/* Icon Container */}
      <div className='flex size-[40px] text-dark-100'>{icon}</div>
    </div>

    {/* Right: Content Column */}
    <div className='flex flex-col gap-1'>
      {/* Title */}
      <span
        className={clsx(
          // Inter V, Medium, 20px, 27px LH, 0% LS, #1C1C1C
          'font-sans text-20 font-medium leading-27 tracking-normal text-dark-100'
        )}
      >
        {title}
      </span>

      {/* Subtitle */}
      <span
        className={clsx(
          // Inter V, Regular, 16px, 20px LH, 0% LS, #1A1036
          'font-sans text-16 font-normal leading-20 tracking-normal text-brand-800'
        )}
      >
        {subtitle}
      </span>
    </div>
  </button>
);
